module.exports = __webpack_public_path__ + "static/media/playpt2.e8ff63f7.png";